import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 31124 26517"
    {...props}
  >
    <defs>
      <style>
        {/* {".str0{stroke:#000;stroke-width:451.069}.fil0{fill:#2b2a29}"} */}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_2528324046368">
        <path
          d="M29144 1628H1981c-118 0-213-95-213-213 0-117 95-212 213-212h27163c117 0 212 95 212 212 0 118-95 213-212 213z"
          className="fill stroke1"
          style={{
            strokeWidth: 451.069,
          }}
        />
        <path
          d="M1168 900c-285 0-516 231-516 515 0 285 231 516 515 516 285 0 516-231 516-516 0-284-231-515-516-515h1zm0 1457c-520 0-942-422-942-942 0-519 422-941 941-941 520 0 942 422 942 941 0 520-422 942-942 942h1zM10557 2180h704V1004c0-194-157-353-351-353-195 0-353 159-353 353v1176zm1131 426h-1557V1004c0-429 349-778 779-778 429 0 778 349 778 778v1602z"
                    className="fill stroke1"
          style={{
            strokeWidth: 451.069,
          }}

        />
        <path
          d="M10910 24404c224 0 449 69 641 206l1471 1054V4860c0-380-166-739-457-985l-1383-1169c-158-134-387-134-545 0L9253 3875c-290 246-457 605-457 985v20804l1471-1054c192-137 417-206 643-206zm2326 1887c-44 0-88-14-124-40l-1809-1294c-236-169-552-169-788 0l-1808 1294c-65 47-150 53-221 17-71-37-116-110-116-190V4860c0-506 222-984 608-1310l1384-1170c317-268 778-268 1095 0l1384 1170c386 326 608 804 608 1310v21218c0 80-45 153-116 190-31 15-64 23-97 23zM5904 2180h705V1004c0-194-158-353-353-353-194 0-352 159-352 353v1176zm1131 426H5479V1004c0-429 348-778 777-778 430 0 779 349 779 778v1602z"
                    className="fill stroke1"
          style={{
            strokeWidth: 451.069,
          }}

        />
        <path
          d="M6256 24404c225 0 450 69 643 206l1471 1054V4860c0-380-166-739-457-985L6529 2706c-158-134-387-134-545 0L4600 3875c-290 246-457 605-457 985v20804l1471-1054c193-137 417-206 642-206zm2327 1887c-44 0-87-14-124-40l-1808-1294c-236-169-553-169-788 0l-1809 1294c-65 47-150 53-221 17-71-37-116-110-116-190V4860c0-506 222-984 608-1310l1384-1170c317-268 777-268 1095 0l1384 1170c386 326 608 804 608 1310v21218c0 80-45 153-116 190-30 15-64 23-97 23zM10910 21349c-118 0-214-96-214-213l1-11079c0-117 95-213 213-213 117 0 212 96 212 213v11079c0 117-95 213-212 213z"
                    className="fill stroke1"
          style={{
            strokeWidth: 451.069,
          }}

        />
        <path
          d="M6256 21349c-117 0-213-96-213-213V10057c0-117 96-213 213-213 118 0 214 96 214 213v11079c0 117-96 213-214 213zM29957 900c-284 0-516 231-516 515 0 285 232 516 516 516s515-231 515-516c0-284-231-515-515-515zm0 1457c-520 0-942-422-942-942 0-519 422-941 942-941 519 0 941 422 941 941 0 520-422 942-941 942zM24515 2180h705V1004c0-194-158-353-353-353-194 0-352 159-352 353v1176zm1131 426h-1557V1004c0-429 349-778 778-778s779 349 779 778v1602z"
                    className="fill stroke1"
          style={{
            strokeWidth: 451.069,
          }}

        />
        <path
          d="M24867 24404c226 0 451 69 642 206l1472 1054V4860c0-380-167-739-457-985l-1385-1169c-157-134-386-134-544 0l-1383 1169c-291 246-458 605-458 985v20804l1472-1054c191-137 416-206 641-206zm2327 1887c-44 0-87-14-124-40l-1808-1294c-236-169-553-169-788 0l-1809 1294c-65 47-150 53-221 17-71-37-116-110-116-190V4860c0-506 222-984 608-1310l1384-1170c317-268 777-268 1095 0l1384 1170c386 326 608 804 608 1310v21218c0 80-45 153-116 190-31 15-64 23-97 23zM19862 2180h705V1004c0-194-158-353-352-353s-353 159-353 353v1176zm1131 426h-1556V1004c0-429 349-778 778-778s778 349 778 778v1602z"
                    className="fill stroke1"
          style={{
            strokeWidth: 451.069,
          }}

        />
        <path
          d="M20215 24404c225 0 450 69 642 206l1471 1054V4860c0-380-167-739-457-985l-1384-1169c-158-134-387-134-545 0l-1384 1169c-290 246-457 605-457 985v20804l1472-1054c192-137 417-206 642-206zm2326 1887c-43 0-87-14-124-40l-1808-1294c-236-169-553-169-789 0l-1807 1294c-65 47-151 53-222 17-71-37-116-110-116-190V4860c0-506 222-984 609-1310l1383-1170c318-268 778-268 1095 0l1384 1170c386 326 608 804 608 1310v21218c0 80-44 153-116 190-30 15-64 23-97 23zM15210 2180h704V1004c0-194-158-353-352-353s-352 159-352 353v1176zm1130 426h-1556V1004c0-429 349-778 778-778s778 349 778 778v1602z"
                    className="fill stroke1"
          style={{
            strokeWidth: 451.069,
          }}

        />
        <path
          d="M15562 2605c-97 0-194 34-273 101l-1383 1169c-291 246-457 605-457 985v20804l1471-1054c384-275 900-274 1284 0l1471 1054V4860c0-380-166-739-457-985l-1384-1169c-78-67-175-101-272-101zm2326 23686c-43 0-87-14-124-40l-1808-1294c-235-169-552-169-788 0l-1809 1294c-64 47-150 53-221 17-71-37-116-110-116-190V4860c0-506 222-984 608-1310l1385-1170c317-268 777-268 1094 0l1384 1170c386 326 608 804 608 1310v21218c0 80-44 153-116 190-30 15-63 23-97 23zM24867 21349c-117 0-212-96-212-213V10057c0-117 95-213 212-213 118 0 213 96 213 213v11079c0 117-95 213-213 213zM20215 21349c-118 0-213-96-213-213V10057c0-117 95-213 213-213 117 0 213 96 213 213v11079c0 117-96 213-213 213z"
                    className="fill stroke1"
          style={{
            strokeWidth: 451.069,
          }}

        />
        <path
          d="M15562 21349c-118 0-213-96-213-213V10057c0-117 95-213 213-213s213 96 213 213v11079c0 117-95 213-213 213z"
                    className="fill stroke1"
          style={{
            strokeWidth: 451.069,
          }}

        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
